import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus.svg",
  "use": "plus.svg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"plus.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 0a.833.833 0 00-.833.833v8.334H.833a.833.833 0 100 1.666h8.334v8.334a.833.833 0 001.666 0v-8.334h8.334a.833.833 0 000-1.666h-8.334V.833A.833.833 0 0010 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol